import * as React from 'react';
import { 
  Box,
  CircularProgress,
  DialogContent,
  IconButton,
} from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField, CSelect, CFormControl } from '../../components/common/Modal';
import MultiSelect from '../../components/common/MultiSelect';

import { getUsers } from '../../slices/user';
import { assignUserToGroup, getUserOfGroup } from '../../slices/group';

export default function AssignUserModal(props) {
  const {open, type, group, defaultValue, handleClose} = props;
  const [loading, setLoading] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [data, setData] = React.useState(defaultValue);

  const dispatch = useDispatch();  

  React.useEffect(() => {
    let formData = new FormData();
    formData.append("page", 1);

    dispatch(getUsers(formData))
      .unwrap()
      .then(data => {
        const newUsers = data.map(item => ({name: item.email}))
        setOptions(newUsers)
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false); // Set loading to false on error
      });
  }, [dispatch]);

  // Update data when the modal opens
  React.useEffect(() => {
    if (open) {
      setData(defaultValue); // Update data with defaultValue when modal opens
    }
  }, [open, defaultValue]);

  const handleSave = (e) => {
    setLoading(true);
    const users = data.map(item => item.name);
    let formData = new FormData();
    formData.append('group', group);
    formData.append('user', users);
    dispatch(assignUserToGroup(formData))
      .then(res => {
        window.alert("Create new user successfully!");
        setLoading(false);
        handleClose();
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      }
    )
  }

  const handleData = (values) => {
    setData(values);
  }
 
  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"sm"}
        fullWidth
      >
        <CDialogTitle>{`Assign ${type}`}</CDialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <DialogContent>
        <MultiSelect
          label={type}
          options={options} 
          value = {data}
          handleChange = {handleData}
        />
        {loading && (
            <Box className="absolute w-full h-full" sx={{top: 0, left: 0}}>
              <Box className="relative w-full h-full">
                <Box className="w-full h-full flex justify-center align-center">
                  <CircularProgress sx={{opacity: 0.7}} />
                </Box>
              </Box>
            </Box>)
          }  
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={handleSave}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}